/**
 * DesktopMenu - Therapist-specific wrapper for shared DesktopMenu
 * 
 * Uses the shared @sophy/shared-ui DesktopMenu component
 * with therapist-specific menu configuration.
 */
import React, { useContext } from "react";
import { DesktopMenu as SharedDesktopMenu } from "@sophy/shared-ui";
import { useNotifications } from "../../context/NotificationContext";
import { AccountContext } from "../../context/AccountContext";

// Therapist-specific icons
import HomeIcon from "../../assets/icons/home-house-big.svg";
import UsersIcon from "../../assets/icons/users.svg";
import TemplatesIcon from "../../assets/icons/templates.svg";
import ExerciseIcon from "../../assets/icons/exercise.svg";
import CameraIcon from "../../assets/icons/camera.svg";
import QuestionIcon from "../../assets/icons/question.svg";
import ChartIcon from "../../assets/icons/chart.svg";
import SettingsIcon from "../../assets/icons/settings.svg";
import NotificationsIcon from "../../assets/icons/notifications.svg";
import LogoutIcon from "../../assets/icons/logout.svg";
import FeedbackIcon from "../../assets/icons/feedbackIcon.svg";
import ReviewIcon from "../../assets/icons/star-review.svg";

const DesktopMenu = ({ content, isHiddenOverflow, logout }) => {
  const { unreadCount } = useNotifications();
  const { userData } = useContext(AccountContext);

  // Therapist main menu items
  const mainMenuItems = [
    { to: "/dashboard", icon: HomeIcon, labelKey: "menu.dashboard", alt: "dashboard" },
    { to: "/patients", icon: UsersIcon, labelKey: "menu.patients", alt: "patients" },
    { to: "/programs", icon: TemplatesIcon, labelKey: "menu.programs", alt: "programs" },
    { to: "/exercises", icon: ExerciseIcon, labelKey: "menu.exercises", alt: "exercises" },
    { to: "/materials", icon: CameraIcon, labelKey: "menu.materials", alt: "materials" },
    { to: "/questionnaires", icon: FeedbackIcon, labelKey: "menu.questionnaires", alt: "questionnaires" },
    { to: "/analysis", icon: ChartIcon, labelKey: "menu.analysis", alt: "analysis" },
    { to: "/preferences", icon: SettingsIcon, labelKey: "menu.settings", alt: "settings" },
    {
      to: "/review",
      icon: ReviewIcon,
      labelKey: "menu.review",
      alt: "review",
      show: userData?.reviewer === 1,
      badge: userData?.openReviewCount > 0 ? (
        <span className="sophy-review-indicator" />
      ) : null,
    },
  ];

  // Therapist footer menu items
  const footerMenuItems = [
    {
      href: "https://hoferdigital.atlassian.net/wiki/spaces/SS/pages/2949775361/therapeut.sophyapp.com+-+Wiki+f+r+Therapeuten",
      icon: QuestionIcon,
      labelKey: "menu.help",
      alt: "help",
      external: true,
    },
    {
      to: "/notifications",
      icon: NotificationsIcon,
      labelKey: "menu.notifications",
      alt: "notifications",
      badge: unreadCount > 0 ? (
        <span className="sophy-notification-badge">{unreadCount}</span>
      ) : null,
    },
  ];

  return (
    <SharedDesktopMenu
      content={content}
      isHiddenOverflow={isHiddenOverflow}
      mainMenuItems={mainMenuItems}
      footerMenuItems={footerMenuItems}
      onLogout={logout}
      logoutIcon={LogoutIcon}
      flushRoutes={["/preferences", "/permissions"]}
    />
  );
};

export default DesktopMenu;
